import { PreparationOrderStatus } from '../../../../data-model/schema/databases/site-preparation-orders/documents/PreparationOrder';

export const INACTIVE_STATUSES: PreparationOrderStatus[] = [
  '01 Pending',
  '05 Collected'
];
